<template>
  <v-app>
    <nav>
      <v-app-bar app dark class="gradient" height="80%">
        <v-container class="fill-height ml-5" align="center">
          <v-btn class="v-btn--icon primary menu-btn"
              small depressed
              @click="closeWindow">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <div class="ml-4">
            <h2 class="secondary--text font-weight-medium">{{ title }}</h2>
          </div>
        </v-container>
        <v-spacer/>
        <logo height="80" class="mr-5"/>
      </v-app-bar>
    </nav>
    <v-main>
      <router-view />
    </v-main>
    <v-snackbar
      v-model="state.message.show"
      bottom
      :color="state.message.color"
      :timeout="state.message.timeout"
    >
      {{ state.message.text }}
    </v-snackbar>
  </v-app>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {
    Logo: () => import('@/components/Logo.vue')
  },
  mounted () {
    this.$router.onReady(() => {
      // Token by JWT otherwise by query param
      this.$store.commit('state/setToken', this.$route.params.token)
      // FacilityId by query param
      const facilityId = this.$route.query.facility_id
      this.$store.commit('state/setFacilityId', facilityId)
      const bookingId = this.$route.query.booking_id
      if (bookingId) {
        this.$store.commit('state/setBookingId', bookingId)
      }
    })
  },
  methods: {
    closeWindow () {
      if (window.opener) {
        window.close()
      }
    }
  },
  computed: {
    ...mapState(['state']),
    title () {
      return this.state.bookingId ? this.$t('nav.edit') : this.$t('nav.title')
    }
  }
}
</script>
<style lang="scss">
html, body {
  overflow: hidden !important;
  height: 100%;
}
.gradient {
  background: linear-gradient(to right, #05bdd3, #241dba);
}
.menu-btn {
  background-color: #5cbdde !important;
  border-radius: 28px !important;
}
.big-icon {
  font-size: 38px !important;
}
.flex-none {
  flex: none !important;
}
.max-height-100 {
  max-height: 100%;
}
.min-height-100 {
  min-height: 100%;
}
.full-height {
  height: 100%;
}
.full-width {
  width: 100%;
}
.rtl {
  direction: rtl;
}
.monospaced {
  font-family: monospace;
  letter-spacing: 1px;
}
.pointer {
  cursor: pointer;
}
// VUETIFY
.v-main {
  max-height: 100vh;
  .v-main__wrap {
    overflow: auto;
    position: relative;
  }
}
.v-btn:not(.v-btn--floating):not(.v-btn--icon) {
  border-radius: 5px !important;
}
</style>
